import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { Field } from 'react-final-form';
import FormCheckboxGroup from 'Shared/components/FormComponents/FormCheckboxGroup';
import Collapsed from '../Collapsed';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

function optionsDecorator(options) {
  return options.map(workspace => ({ value: workspace.id, label: workspace.label }));
}

export default function UsersFilter() {
  const { tr } = useTranslation();
  const workspaces = useSelector(state => state.workspaces);

  const [isAllResults, setIsAllResults] = useState(workspaces.length <= 3);

  const options = optionsDecorator(isAllResults ? workspaces : workspaces.slice(0, 3));

  const handleAllResultsToggle = useCallback(() => setIsAllResults(!isAllResults), [isAllResults]);

  if (!options.length) return null;

  return (
    <div className="d-flex flex-column">
      <Collapsed title={tr('perform.search.sidebar.workspaces.title')}>
        <Field name="workspacesIds" options={options} component={FormCheckboxGroup} />
        {!isAllResults ? (
          <button className="btn btn-link text-left p-0 " type="button" onClick={handleAllResultsToggle}>
            {tr('perform.search.workspaces_filter.more_button')}
          </button>
        ) : null}
      </Collapsed>
    </div>
  );
}
